import frontend from "@/env/frontend";

export default {
  enableTableau: frontend.VITE_ENABLE_TABLEAU,
};
